import { capitalizeName } from './names';

// Airport meet & greet helpers (website booking). The server is the judge: it re-checks everything; these rules just give an instant message.
export const MAX_SIGN_NAME = 40;

const LINKISH = /(https?:|www\.|ftp:|mailto:|tel:|sms:|javascript:|data:|@|:\/\/|\b[a-z0-9-]+\.(com|net|org|io|co|us|app|ly|me|info|biz|xyz|ru|cn|uk|to|gl|gd)\b)/i;

export function tidyName(value) {
  return String(value || '').replace(/[\u0000-\u001f\u007f​-‏‪-‮⁠-⁯﻿]/g, ' ').split(/\s+/).filter(Boolean).join(' ');
}

// '' when fine, otherwise the message to show under the field.
export function signNameProblem(value) {
  const v = tidyName(value);
  if (!v) return 'Enter the name for the sign.';
  if (v.length > MAX_SIGN_NAME) return `The name on the sign can be at most ${MAX_SIGN_NAME} characters.`;
  if (/[<>]/.test(v) || LINKISH.test(v)) return "The name on the sign can't contain links, web addresses or symbols like < >.";
  return '';
}

export function defaultSignName(user) {
  return capitalizeName(tidyName(`${user?.firstName || ''} ${user?.lastName || ''}`)).slice(0, MAX_SIGN_NAME);
}

// Font size (in % of the sign's width) so long names still fit on one or two lines.
export function signFontScale(name) {
  const n = tidyName(name).length;
  if (n <= 10) return 1;
  if (n <= 18) return 0.75;
  if (n <= 28) return 0.55;
  return 0.42;
}

export async function fetchMeetGreetOptions(base, token) {
  const r = await fetch(`${base}/api/meet-greet/options`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  return r.ok ? r.json() : null;
}

// Where the chauffeur will meet the rider. Pass the airport (code) or the pickup point, the terminal if known, and the flight + date.
export async function fetchMeetingPoint(base, token, { airport, lat, lng, terminal, flightNumber, date }) {
  const q = new URLSearchParams();
  if (airport) q.set('airport', airport);
  if (lat != null && lng != null) { q.set('lat', lat); q.set('lng', lng); }
  if (terminal) q.set('terminal', terminal);
  if (flightNumber) q.set('flight_number', flightNumber);
  if (date) q.set('date', date);
  const r = await fetch(`${base}/api/meet-greet/meeting-point?${q.toString()}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  return r.ok ? r.json() : null;
}
